import { API_URL } from '../../../../constants'

export const DETAILED_PAYMENT_TICKETS_URL = `${API_URL}/api/reports/tickets/payment/detailed`
export const DETAILED_PAYOUT_TICKETS_URL = `${API_URL}/api/reports/tickets/payout/detailed`

export const MATCHING_PAYOUT_SUMMARY_URL = `${API_URL}/api/reports/tickets/matching-payout/summary`
export const MATCHING_PAYOUT_DETAILED_URL = `${API_URL}/api/reports/tickets/matching-payout/detailed`
export const MATCHING_PAYOUT_FULL_URL = `${API_URL}/api/reports/tickets/matching-payout/full`

export const PAYMENT_TICKET_CLOSE_REASON_LOOKUP_URL = `${API_URL}/api/internal/payment-ticket-close-reason/lookup`
